import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-succeed-big",
  "use": "app-icon-succeed-big-usage",
  "viewBox": "0 0 80 80",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 80 80\" id=\"app-icon-succeed-big\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#A6DD82\" cx=\"40\" cy=\"40\" r=\"40\" /><path stroke=\"#FFF\" stroke-width=\".4\" fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M35.7 54L24 39.338l2.501-2.31 9.153 8.828L55.617 26 58 28.38z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol